import api from '../../api'

export default function getOffer(brandId,offerId) {
  return api.get(`/brands/manage/${brandId}/offers/${offerId}`);
}